import { Icon as RawIcon, IconName } from '@lyse-as/formds-icons';
import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'fds-icon',
  styleUrl: 'icon.scss',
  shadow: true,
})
export class Icon {
  /**
   * Which actual icon to show. Supply the name of the icon you want to render.
   */
  @Prop({ reflect: true }) name!: IconName;

  /**
   * The size of the icon. This is a shorthand that sets both width and height to same value
   */
  @Prop() size: number;

  /**
   * Sets the width of the icon
   */
  @Prop() width: number;

  /**
   * Sets the height of the icon
   */
  @Prop() height: number;

  /**
   * Sets the color of the icon
   */
  @Prop() color: string;

  private getIcon() {
    return RawIcon[this.name];
  }

  private getSvgAttributes() {
    const icon = RawIcon[this.name];
    if (icon.name === 'svg') {
      return icon.attributes;
    }
  }

  render() {
    const defaultSvgAttributes = this.getSvgAttributes();
    const svgAttributes = {
      ...defaultSvgAttributes,
      width: this.size || this.width || defaultSvgAttributes.width,
      height: this.size || this.height || defaultSvgAttributes.height,
    };

    return (
      <svg {...svgAttributes} fill={this.color}>
        {this.getIcon().children.map((child) => {
          if (child.name === 'path') {
            return <path d={child.attributes.d} fill={this.color ?? child.attributes.fill} />;
          }
        })}
      </svg>
    );
  }
}
